/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.Employee {
  angular.module("meevo.plugins.employee", []);
}